module.exports = __webpack_public_path__ + "static/ride-founder-01fb07e286f802a29131de184c43f2a6.png";